import React from "react";
import styled, { withTheme } from "styled-components";
import { BodyStyle } from "storybook-components/Typography";

const StyledDiv = styled.div`
  .mktoForm .mktoFormRow .mktoFieldWrap {
    label[for="Email_Opt_In_GDRP__c_lead"],
    label[for="optInGeneralCommunications"] {
      ${BodyStyle};
      color: ${({ theme }) => theme.colors.gray1};
      font-weight: 400;
      display: block;
      padding: 5px;
      margin-bottom: 24px;
      width: auto !important;
    }
  }
  .isEmailOptFormRow {
    margin-top: 24px;
    .mktoFormCol .mktoFieldWrap {
      display: flex;
      flex-direction: row-reverse !important;
    }
    .mktoCheckboxList {
      margin-top: 10px;
      width: 25%;
      ${({ theme }) => theme.media.desktopUp`
        width: auto !important;
      `};
      .mktoField {
        border-radius: 4px;
        border-color: ${({ theme }) => theme.colors.green2};
      }
    }
    .mktoAsterix {
      display: none !important;
    }
  }
  .mktoLogicalField.mktoCheckboxList.mktoHasWidth {
    padding: 5px 0;
  }
`;

const MarketoButtonStyleBase = ({ children }) => (
  <StyledDiv>{children}</StyledDiv>
);

export default withTheme(MarketoButtonStyleBase);
